/**
 * Lock-Screen fuer Endnutzer eines nicht-aktiven Mandanten.
 *
 * P3 (docs/KONZEPT-ADMIN-BEREICH.md § "Lock-Screen im Frontend", docs/LOOP-ADMIN-BEREICH.md § P3
 * sechstes/letztes Nicht-Gate-Kriterium). Baut auf zwei bereits abgeschlossenen P3-Kriterien auf:
 * `TenantGesperrtError` (`apps/api/src/lib/db.ts`) setzt serverseitig durch, dass ein Mandant mit
 * `status != 'aktiv'` (Migration 375) keine tenant-gebundenen Daten mehr ausliefert; `GET /api/me`
 * liefert seither je Mitgliedschaft ein `status`-Feld mit. Diese Seite ist die dazugehoerige
 * Frontend-Konsequenz: STATT der normalen App-Shell/Outlet erscheint diese neutrale Hinweisseite.
 *
 * Existenz-Orakel-Grundsatz (KONZEPT-ADMIN-PANEL.md Punkt 5, hier fortgefuehrt): das ist NICHT der
 * Admin-Lock-Screen (Platform-Admins sehen ueber `maestro.<domain>` ohnehin alles) — das ist die
 * Seite fuer einen NORMALEN Endnutzer/Mitarbeiter des gesperrten/archivierten Mandanten selbst. Er
 * darf aus dem sichtbaren Text nicht mehr erfahren, als noetig: kein "gesperrt"/"archiviert" (das
 * waere ein interner Verwaltungszustand, den nur ein Platform-Admin kennen muss) und kein "Admin"
 * (verraet die Existenz eines separaten Betreiber-Bereichs). Der Wortlaut bleibt deshalb so neutral
 * wie eine gewoehnliche Nichtverfuegbarkeits-/Wartungsmeldung. Geprueft in
 * `apps/web/test/bereich-gesperrt.test.tsx` per Regex ueber den gesamten sichtbaren Text.
 *
 * Kein Datenleck: die Komponente ersetzt in `MitgliedschaftsGate` die komplette Shell/den
 * kompletten `Outlet` (CopilotProvider/AppShell/Seiteninhalt) — kein tenant-gebundener Datenabruf
 * startet, keine App-Funktion ist erreichbar.
 */
import { Icon } from "../ui/components";

export function BereichNichtVerfuegbarSeite() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-6 py-12 font-body-md text-on-surface">
      <div className="w-full max-w-lg rounded-xl bg-surface-container-lowest p-8 text-center shadow-[0_8px_30px_rgb(0,0,0,0.08)]">
        <div className="mx-auto mb-4 grid h-12 w-12 place-items-center rounded-xl bg-primary/10 text-primary">
          <Icon name="info" className="text-[24px]" />
        </div>
        <h1 className="font-headline-sm text-headline-sm font-semibold text-on-background dark:text-inverse-on-surface">
          Dieser Bereich ist derzeit nicht verfügbar
        </h1>
        <p className="mt-3 font-body-sm text-body-sm text-on-surface-variant">
          Bitte wenden Sie sich an unseren Support, falls Sie Fragen dazu haben.
        </p>
      </div>
    </div>
  );
}

export default BereichNichtVerfuegbarSeite;
